import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { DisconnectedDrivingsList } from "./DisconnectedDrivingsList";

export default {
  list: DisconnectedDrivingsList,
  icon: ReportProblemOutlinedIcon,
};
